import React, { FunctionComponent } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ButtonProps, EditButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { getCiEditFileRecordContentPageHref } from "../../../../ContentIngestionRoutes";

export type EditContentButtonProps = ButtonProps & { disabled: boolean };

export const EditContentButton: FunctionComponent<EditContentButtonProps> = ({ disabled }: EditContentButtonProps) => {
    const { fileRecordId } = useParams<{ fileRecordId: string }>();
    const history = useHistory();

    const moveToEditFileRecordContentPage = () => {
        const href = getCiEditFileRecordContentPageHref(fileRecordId);
        history.push(href);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={moveToEditFileRecordContentPage}
                label="Edit"
                isLabeled
                testId="edit-content"
                disabled={disabled}
            />
        </AuthorizationWrapper>
    );
};
